import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { config } from "../../configuration/app/app-config"
import { accessToken } from "../../configuration/token/accessToken"
import { MainRunData } from "../../model/mainrun/mainRunData"
import { ICrossDock } from "../../model/crossdock/crossDock"
import {
    crossDockListSchema,
    mainRunListSchema
} from "./asnMatchingApi.model"
import { toCrossDock, toMainRun, toMainRunDataRest } from "./asnMatchingApi.converter"


const url = config.asnMatchingApi.baseUrl

const GET_MAIN_RUNS_API_TAG = "GET_MAIN_RUNS"

export const asnMatchingApi = createApi({
    reducerPath: "asnMatchingApi",
    tagTypes: [GET_MAIN_RUNS_API_TAG],
    baseQuery: fetchBaseQuery({
        baseUrl: url,
        prepareHeaders: (headers) => {
            headers.set("authorization", `Bearer ${accessToken.getAccessToken()}`)
            headers.set("accept", "application/json")
            return headers
        },
    }),
    endpoints: (builder) => ({
        getMainRuns: builder.query<MainRunData[], void>({
            query: () => "/main-runs",
            transformResponse: (response: unknown) => {
                const mainRuns = mainRunListSchema.parse(response)
                return mainRuns.items.map(toMainRun)
            },
            keepUnusedDataFor: 1, // generally, caching is not needed for this endpoint
            providesTags: [{ type: GET_MAIN_RUNS_API_TAG }],
        }),
        getCrossDocks: builder.query<ICrossDock[], void>({
            query: () => "/cross-docks",
            transformResponse: (response: unknown) => {
                const crossDocks = crossDockListSchema.parse(response)
                return crossDocks.map(toCrossDock)
            },
        }),
        postMainRuns: builder.mutation<MainRunData[], MainRunData[]>({
            query: (data) => ({
                url: "/main-runs",
                method: "POST",
                body: {
                    items: data.map(toMainRunDataRest),
                },
            }),
            transformResponse: (response: unknown) => {
                const mainRuns = mainRunListSchema.parse(response)
                return mainRuns.items.map(toMainRun)
            },
            invalidatesTags: [{ type: GET_MAIN_RUNS_API_TAG }],
        }),
    }),
})

export const {
    useLazyGetMainRunsQuery,
    useGetCrossDocksQuery,
    usePostMainRunsMutation,
} = asnMatchingApi
